import { TolgeeStaticData } from '@tolgee/react';
import { TolgeeStaticDataProp } from '@tolgee/i18next';

export const tolgeeStaticData: TolgeeStaticDataProp = {
  'en:common': () => import('@public/translated/common/en.json'),
  'fr:common': () => import('@public/translated/common/fr.json'),

  'en:error-message': () => import('@public/translated/error-message/en.json'),
  'fr:error-message': () => import('@public/translated/error-message/fr.json'),
};

export const i18nNamespaceMap: Array<keyof TolgeeStaticData> = [
  'common',
  'error-message',
] as string[];
